import { Controller } from '@hotwired/stimulus';
import { GROUP_NAME } from './consts';
/*
 * Description
 * -------
 *
 * Sorts supporters badges.
 *
 * Can be used on any element.
 * Can be used multiple times in the document.
 *
 * Targets
 * -------
 *
 * visible - (required) - visible badges container
 * hidden  - (required) - hidden badges container
 *
 * Classes
 * -------
 *
 * handle - (required) - handle element class
 *
 * Usage
 * -------
 *
 * <div data-controller="badges-sort" data-badges-sort-handle-class='.class'>
 *   <ul id="visible" data-badges-sort-target="visible">
 *     <li>
 *       <input type="hidden" name="badges[1][hidden]" value="true">
 *       <input type="hidden" name="badges[1][id]" value=1>
 *     </li>
 *   </ul>
 *   <ul id="hidden" data-badges-sort-target="hidden">
 *     <li>
 *       <input type="hidden" name="badges[2][hidden]" value="true">
 *       <input type="hidden" name="badges[2][id]" value=2>
 *     </li>
 *   </ul>
 * </div>
 */
export class BadgesSort extends Controller {
    static targets = ['visible', 'hidden'];
    static classes = ['handle'];
    async connect() {
        const { default: Sortable } = await import('sortablejs');
        new Sortable(this.visibleTarget, {
            group: GROUP_NAME,
            handle: this.handleClass,
            animation: 150,
            onEnd: (event) => {
                if (!(event.item.firstElementChild instanceof HTMLInputElement))
                    return;
                event.item.firstElementChild.value = event.to.id === 'hidden' ? '1' : '0';
            },
        });
        new Sortable(this.hiddenTarget, {
            group: GROUP_NAME,
            handle: this.handleClass,
            animation: 150,
            onEnd: (event) => {
                if (!(event.item.firstElementChild instanceof HTMLInputElement))
                    return;
                event.item.firstElementChild.value = event.to.id === 'hidden' ? '1' : '0';
            },
        });
    }
}
